import { TSiteSettings } from '../../../../types';
import * as config from '../../../../config';

export const settings: TSiteSettings = {
  id: 'default-settings',
  locale: config.app.default.locale,
  error: 'default-page-error',
  uc: 'default-page-uc',
};
